import React from 'react';
import { useTranslation } from 'react-i18next';
import { BsBarChartLineFill } from 'react-icons/bs';
import { Col } from 'react-bootstrap';
import { SocialPlatformPostings } from '../../../../../../shared/components/social/SocialPlatformPostings';
import { formatDate } from '../../../../../../shared/functions/Functions';
import { ICampaignOverview } from '../../../../../../model/briefing/overview/ICampaignOverview';
import DOMPurify from 'dompurify';
import TooltipOverlay from '../../../../../../shared/components/tooltip/Tooltip';
import { FiInfo } from 'react-icons/fi';

interface IOverviewTabProps {
    campaign?: ICampaignOverview;
}

export function OverviewTab({ campaign }: IOverviewTabProps) {
    const { t } = useTranslation();
    const isLongTermContractModal = campaign?.isLongTerm && !!campaign.contracts;
    return (
        <div className="d-flex flex-wrap">
            <Col xs={12}>
                <h6 className="text-muted">{t('influencer.offer_management.modal.campaign_goal')}</h6>
            </Col>
            <Col xs={12}>
                <div className="d-flex align-items-center mb-3 text-muted">
                    <BsBarChartLineFill className="text-dark" size={32} />
                    <h4 className="mb-0 ml-2 text-primary">
                        {campaign?.campaignGoal ? campaign?.campaignGoal?.title : '--'}
                    </h4>
                </div>
            </Col>
            {isLongTermContractModal ? (
                <>
                    <Col className="my-2" xs={6} md={3}>
                        <h6 className="text-muted">{t('brand.campaign.briefing.step3.start_date')}</h6>
                        <h6 className="text-primary">
                            {!!campaign?.date?.length ? formatDate(campaign?.date as string) : '-'}
                        </h6>
                    </Col>
                    <Col className="my-2" xs={6} md={3}>
                        <h6 className="text-muted">{t('brand.campaign.briefing.step3.campaign_duration')}</h6>
                        <h6 className="text-primary">
                            {!!campaign?.invoiceDuration
                                ? t(`brand.campaign.briefing.step3.campaign_duration_enum.${campaign?.invoiceDuration}`)
                                : '-'}
                        </h6>
                    </Col>
                    <Col className="my-2 d-flex" xs={6} md={3}>
                        <div>
                            <h6 className="text-muted">{t('brand.campaign.briefing.step8.payout_method')}</h6>
                            <h6 className="text-primary">
                                {!!campaign?.invoicePeriod
                                    ? t(`brand.campaign.briefing.step8.payment_method.${campaign?.invoicePeriod}`)
                                    : '-'}
                            </h6>
                        </div>
                        <TooltipOverlay
                            className="ms-2"
                            content={t(`brand.campaign.briefing.step8.payout_method_tooltip`)}
                        >
                            <FiInfo size={14} />
                        </TooltipOverlay>
                    </Col>
                </>
            ) : (
                <>
                    <Col className="my-2" xs={6} md={3}>
                        <div>
                            <h6 className="text-muted">{t('influencer.offer_management.modal.publication_period')}</h6>
                            <h6 className="text-primary">
                                {campaign?.publishFrom ? formatDate(campaign?.publishFrom as string) : '-'}-
                                {campaign?.publishTo ? formatDate(campaign?.publishTo as string) : ' -'}
                            </h6>
                        </div>
                    </Col>
                    <Col className="my-2" xs={6} md={3}>
                        <div>
                            <h6 className="text-muted">
                                {t('influencer.offer_management.modal.content_approval_deadline')}
                            </h6>
                            <h6 className="text-primary">{campaign?.isReviewed ? campaign.reviewDays : '-'}</h6>
                        </div>
                    </Col>
                    <Col className="my-2" xs={6} md={3}>
                        <div>
                            <h6 className="text-muted">
                                {t('influencer.offer_management.modal.application_deadline')}
                            </h6>
                            <h6 className="text-primary">
                                {campaign?.date ? formatDate(campaign?.date as string) : '-'}
                            </h6>
                        </div>
                    </Col>
                    <Col className="my-2" xs={6} md={3}>
                        <div>
                            <h6 className="text-muted">{t('influencer.offer_management.modal.reporting_deadline')}</h6>
                            <h6 className="text-primary">
                                {campaign?.postingDeadline ? formatDate(campaign?.postingDeadline as string) : '-'}
                            </h6>
                        </div>
                    </Col>
                </>
            )}
            <Col className="my-2" xs={12}>
                <h6 className="text-muted">{t('influencer.offer_management.modal.product_description')}</h6>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(campaign?.details ?? '-') }} />
            </Col>
        </div>
    );
}
